module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/ly-9d867c1b9d3b76652858a0c5505718bb.svg";